export default (set, get, projectId) => {

  const state = get() || {};
  const cabinetVisualizer = state.cabinetVisualizer || {};
  const projects = cabinetVisualizer.projects || {};

  const existingProject = projects[projectId] || {};

  const updatedProject = {
    ...existingProject,
    isCarted: true
  };

  const updatedCabinetVisualizer = {
    ...cabinetVisualizer,
    projects: {
      ...projects,
      [projectId]: updatedProject
    }
  };

  const updatedState = {
    ...state,
    cabinetVisualizer: updatedCabinetVisualizer
  };

  set(
    updatedState,
    false,
    { type: 'cabinetVisualizer/updateProjectCarted' }
  );
};